export default __webpack_public_path__ + "static/media/techbg.9426a548.jpg";